import createPersistedState from "vuex-persistedstate";
import SecureLS from 'secure-ls'
import Vue from 'vue'
import Vuex from 'vuex'
import auth from "@/store/auth";
import helpers from "@/store/helpers";
import individual_entity from "@/store/individual_entity";
import project from "@/store/project";
import ticket from "@/store/ticket";
import promocode from "@/store/promocode";
import legal_entity from "@/store/legal_entity";
import role from "@/store/role";


const ls = new SecureLS({isCompression: false});

Vue.use(Vuex)




export default new Vuex.Store({
    modules: {
        auth,
        helpers,
        project,
        ticket,
        promocode,
        role,
        individual_entity,
        legal_entity,
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key)
            }
        })],
})


